import CacheEnabledApiClient from './CacheEnabledApiClient';

const buildFormData = ({ shortCode, content, audioFile, photos }) => {
  const formData = new FormData();
  if (shortCode !== undefined && shortCode !== null) {
    formData.append('canned_response[short_code]', shortCode);
  }
  if (content !== undefined && content !== null) {
    formData.append('canned_response[content]', content);
  }
  if (audioFile instanceof File) {
    formData.append('canned_response[audio_file]', audioFile);
  }
  if (Array.isArray(photos)) {
    photos.forEach(photo => {
      if (photo instanceof File) {
        formData.append('canned_response[photos][]', photo);
      }
    });
  }
  return formData;
};

const hasFiles = payload =>
  payload?.audio_file instanceof File ||
  (Array.isArray(payload?.photos) && payload.photos.length > 0);

class CannedResponse extends CacheEnabledApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'canned_response';
  }

  // The index endpoint returns a bare array instead of a payload wrapper
  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  create(payload) {
    if (hasFiles(payload)) {
      const formData = buildFormData({
        shortCode: payload.short_code,
        content: payload.content,
        audioFile: payload.audio_file,
        photos: payload.photos,
      });
      return axios.post(this.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return super.create(payload);
  }

  update(id, payload) {
    if (hasFiles(payload)) {
      const formData = buildFormData({
        shortCode: payload.short_code,
        content: payload.content,
        audioFile: payload.audio_file,
        photos: payload.photos,
      });
      return axios.patch(`${this.url}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return super.update(id, payload);
  }

  removeAudio(id) {
    return axios.delete(`${this.url}/${id}/audio`);
  }

  removePhoto(id, photoId) {
    return axios.delete(`${this.url}/${id}/photos/${photoId}`);
  }
}

export default new CannedResponse();
